import {
  getTotalDataUsage,
  getTotalActiveAgents,
  getLicenseUsageForServices,
  getCapabilityLicenseUsage,
  getLicenseDistributonData,
  getLicenseUsageData,
  getUsedCapacityData,
  getLicenseExpiry,
  getTopLicenseApplication,
} from '@/services/graphQl/fragments/billing';

export const queryTotalSize = `query getTotalSize(${getTotalDataUsage.variable}) {${getTotalDataUsage.query}}`;
export const queryTotalActiveAgents = `query getActiveAgents(${getTotalActiveAgents.variable}) {${getTotalActiveAgents.query}}`;
export const queryLicenseUageForServices = `query GetLicenseUsageForServices(${getLicenseUsageForServices.variable}) {${getLicenseUsageForServices.query}}`;
export const queryTopLicenseApplication = `query GetTopLicenseApp(${getTopLicenseApplication.variable}) {${getTopLicenseApplication.query}}`;
export const queryCapabilityLicenseUsage = `query GetLicenseUsage(${getCapabilityLicenseUsage.variable}) {${getCapabilityLicenseUsage.query}}`;
export const queryLicenseDistributionData = `query GetLicenseDistribution(${getLicenseDistributonData.variable}) {${getLicenseDistributonData.query}}`;
export const queryLicenseUsageData = `query GetLicenseUsageConsumption(${getLicenseUsageData.variable}) {${getLicenseUsageData.query}}`;
export const queryLicenseUsedCapacityData = `query GetLicenseUsageConsumption(${getUsedCapacityData.variable}) {${getUsedCapacityData.query}}`;
export const queryLicenseExpiry = `query GetLicenseExpiry(${getLicenseExpiry.variable}) {${getLicenseExpiry.query}}`;
